<template>
 <!-- <h1 v-show="initialProjects">initialProjects</h1>
<h1 v-show="showSeriesOnly">showSeriesOnly</h1>
<h1 v-show="showTopicOnly">showTopicOnly</h1>
<h1 v-show="showSeriesTopic">showSeriesTopic</h1>

pubseries={{publicationSeries}}<br>
pubRTopics={{publicationTopics}}<br>
pubSort={{publicationSort}}<br>
pubSortDate={{publicationSortDate}}<br>
search_input={{search_input}}<br>
sortField={{sortField}}<br> -->
<form role="search" method="get" id="publications-search" class="form-search-app form-search--publication searchform row">

<input
  class="form-control onpage-control col-12"
  type="text"
  placeholder="Search Think Publications"
  v-model="search_input"
  @change="onSearchInput" 
  />
<div class="col-12 pl-0 pr-0">
  <nav class="navbar-filter">

          <ul class="nav-filter" id="do-filters">
            
            <div v-if="seriesLoading || topicsLoading" class="lds-spinner-small text-center"></div>
            
            <template v-else>
              
              <DropdownItems class="nav-filter__item dropdown do-filter-services thinkDropdown pl-0" :options="seriesResult.publicationSeriesItems.nodes" :key="sortOptions" 
                :selected="publicationSeries" placeholder="Series" v-on:updateOption="seriesSelect" :clear="true">
              </DropdownItems>
            
              <DropdownItems class="nav-filter__item dropdown do-filter-services thinkDropdown" :options="topicsResult.topics.nodes" :key="sortOptions" 
                  :selected="publicationTopics" placeholder="Topic" v-on:updateOption="topicSelect" :clear="true">
                </DropdownItems>

            </template>

            
            
            
            <DropdownItems class="nav-filter__item dropdown do-filter-services thinkDropdown" :options="sortOptions" :key="sortOptions" 
              :selected="publicationSort" placeholder="Sort By" v-on:updateOption="sortSelect" :clear="true">
            </DropdownItems>

          </ul>

  </nav>
</div>
<!-- {{search_input}} -->
</form>

   <!-- <h1>Sort Options:{{sortOptions}}</h1>
  <h2>publicationsSort={{publicationSort}}</h2> -->

  <!-- <DropdownItems class="thinkDropdown" :options="statusResult.statuses.nodes" :key="statusResult.statuses.nodes.name"
          :selected="projectStatus" placeholder="Status" v-on:updateOption="statusSelect">
        </DropdownItems> -->

  <!-- {{searchVariables}} -->
  <!-- {{computedResults}} -->

  <div class="row row--think-content">

    <!-- Load Series Results -->

    <div v-if="initialProjects" class="col-md-12 text-left">
      
      <div class="lds-spinner text-center" v-if="initialLoading"></div>

      <!-- Present Series Filters -->
      
      <section v-else class="publications-results" id="publications-results">
        <!-- initialResult -->
        <p class="no-results-found text-center position-absolute" style="z-index:999; background-color: transparent; width: 100%;" v-if="initialResult.publications.nodes == 0">
            No Results Found
        </p>
        <!-- {{initialVariables}} -->
        <!-- <pre>{{initialResult}}</pre> -->
        
        <!-- Hello
        {{initialError}}
        {{initialVariables}}
         -->
        <!-- {{computedResults.length}} -->
        <!-- <pre>{{computedResults}}</pre> -->
        
          <div class="box-publications">

          <div class="pre-results searchwp-live-search-results page-template-page-think">

            <template v-for="(resultItem, index) in initialResult.publications.nodes" :key="resultItem">

              <div v-if="index < publicationsToShow" class="bootstrap_item col-md-3 mb-5">

                <a v-bind:href="resultItem.link">
                  
                  <template v-for="attachmentUrl in resultItem.attachedMedia.nodes" :key="attachmentUrl">

                    <img v-bind:src="imgageUrl(attachmentUrl.sourceUrl)">

                  </template>

                </a>

              </div>

            </template>

          </div>
          <template v-if="initialResult.publications.nodes.length > publicationsToShow">
            <button class="btn btn-md btn-white btn-center load-publications" @click="showMoreResults">Load More</button>
          </template>
        </div>

      </section>

    </div>

    <div v-if="showSeriesOnly" class="col-md-12 text-left">
      
      
      <div class="lds-spinner text-center" v-if="publicationsSeriesLoading"></div>
      
      <!-- Present Series Filters -->
      
      <section v-else class="publications-results" id="publications-results">
        <p class="no-results-found text-center position-absolute" style="z-index:999; background-color: transparent; width: 100%;" v-if="publicationsSeriesResult.publications.nodes == 0">
            No Results Found
        </p>
        {{publicationsSeriesError}}
        <div class="box-publications">

          <div class="pre-results searchwp-live-search-results page-template-page-think">

            <template v-for="(resultItem, index) in publicationsSeriesResult.publications.nodes" :key="resultItem">

              <div v-if="index < publicationsToShow" class="bootstrap_item col-md-3 p-3 mb-5">

                <a v-bind:href="resultItem.link">
                  
                  <template v-for="attachmentUrl in resultItem.attachedMedia.nodes" :key="attachmentUrl">

                    <img v-bind:src="imgageUrl(attachmentUrl.sourceUrl)">

                  </template>

                </a>

              </div>

            </template>

          </div>

          <template v-if="publicationsSeriesResult.publications.nodes.length > publicationsToShow">
          
            <button class="btn btn-md btn-white btn-center load-publications" @click="showMoreResults">Load More</button>
          
          </template>
        </div>

      </section>

    </div>

    <div v-if="showTopicOnly" class="col-md-12 text-left">
      
      <!-- <h1>TOPIC ONLY Projects</h1> -->

      
      <div class="lds-spinner text-center" v-if="publicationsTopicsLoading"></div>

      <!-- Present Series Filters -->
      
      <section v-else class="publications-results" id="publications-results">
        
        <!-- {{computedTopicsResults}} -->
        <p class="no-results-found text-center position-absolute" style="z-index:999; background-color: transparent; width: 100%;" v-if="publicationsTopicsResult.publications.nodes == 0">
            No Results Found
        </p>
        
        <div class="box-publications">

          <div class="pre-results searchwp-live-search-results page-template-page-think">

            <template v-for="(resultItem, index) in publicationsTopicsResult.publications.nodes" :key="resultItem">

              <div v-if="index < publicationsToShow" class="bootstrap_item col-md-3 p-3 mb-5">

                <a v-bind:href="resultItem.link">
                 <!-- {{resultItem.title}} -->
                  <template v-for="attachmentUrl in resultItem.attachedMedia.nodes" :key="attachmentUrl">

                    <img v-bind:src="imgageUrl(attachmentUrl.sourceUrl)">

                  </template>

                </a>

              </div>

            </template>

          </div>
          
          <template v-if="publicationsTopicsResult.publications.nodes.length > publicationsToShow">
            
            <button class="btn btn-md btn-white btn-center load-publications" @click="showMoreResults">Load More</button>
          
          </template>


        </div>

      </section>

    </div>

    <div v-if="showSeriesTopic" class="col-md-12 text-left">
      
      <!-- <h1>SERIES AND TOPIC</h1> -->

      <!-- <p v-if="publicationsSeriesTopicLoading"></p> -->
      <div class="lds-spinner text-center" v-if="publicationsSeriesTopicLoading"></div>

      <!-- Present Series Filters -->
      
      <section v-else class="publications-results" id="publications-results">
        <p class="no-results-found text-center position-absolute" style="z-index:999; background-color: transparent; width: 100%;" v-if="publicationsSeriesTopicResult.publications.nodes == 0">
            No Results Found
        </p>
        <!-- {{computedPublicationTopicsResults.length}}{{computedPublicationTopicsResults}} -->
            <!-- showSeriesTopic   {{publicationsSeriesTopicResult}} enseriestopic
            {{publicationsSeriesTopicError}} -->
<!-- {{publicationsSeriesTopicResult}}
            {{publicationsSeriesTopicVariables}}
            {{publicationsSeriesTopicResult.publications.nodes}} -->
        <div class="box-publications">
  
          <div class="pre-results searchwp-live-search-results page-template-page-think">

            <template v-for="(resultItem, index) in publicationsSeriesTopicResult.publications.nodes" :key="resultItem">

              <div v-if="index < publicationsToShow" class="bootstrap_item col-md-3 p-3 mb-5">

                <a v-bind:href="resultItem.link">
                  <!-- {{resultItem.title}} -->
                  <template v-for="attachmentUrl in resultItem.attachedMedia.nodes" :key="attachmentUrl">

                    <img v-bind:src="imgageUrl(attachmentUrl.sourceUrl)">

                  </template>

                </a>

              </div>

            </template>

          </div>
          <template v-if="publicationsSeriesTopicResult.publications.nodes.length > publicationsToShow">
            <button class="btn btn-md btn-white btn-center load-publications" @click="showMoreResults">Load More</button>
          </template>
        </div>

      </section>

    </div>


  </div>

</template>

<script setup>

import { ref, provide, computed, watch } from "vue";
import { useQuery } from "@vue/apollo-composable";
import gql from "graphql-tag";
import { useDebouncedRef } from './debouncedRef'

import getPublicationsSeriesNames from '../graphql/getPublicationsSeriesNames.gql'
import getTopics from '../graphql/getTopics.gql'
import publicationsInitialQuery from '../graphql/publicationsInitialQuery.gql'
import publicationsByTitleQuery from '../graphql/publicationsByTitleQuery.gql'

import publicationsSeriesTopics from '../graphql/publicationsSeriesTopics.gql'
import getSeriesOnlyResult from '../graphql/getSeriesOnlyResult.gql'
import getTopicsOnlyResult from '../graphql/getTopicsOnlyResult.gql'

import publicationsSearchAllQuery from '../graphql/publicationsSearchAllQuery.gql'


import DropdownItems from '../components/DropdownItems.vue';


let publicationSeries = ref([]);
let publicationTopics = ref([]);


let initialProjects = ref(true)
let showSeriesOnly = ref(false)
let showTopicOnly = ref(false)

let showSeriesTopic = ref(false)
let noResults = ref(false)


let sortOptions = ref([
                        {'value': 'FEAT', 'name': 'Featured'},
                        {'value': 'ASC', 'name': 'Title (A-Z)'},
                        {'value':'DESC', 'name': 'Title (Z-A)'}
                      ])
let sortField = ref('DATE')
let publicationSort = ref('DESC')
let publicationSortDate = ref('DESC')
let featuredPublications = ref(true)




let search_input = useDebouncedRef('');

const seriesSelect = (payload) => {
  // projectTopics.value = payload.termTaxonomyId.toString()
  // optionsCheck()
    

  if(payload.termTaxonomyId){
    console.log( 'payload services has termtaxid' )
    publicationSeries.value = payload.termTaxonomyId.toString()
    optionsCheck()
    console.log( publicationSeries )
    
  } else {
    console.log('notaxID');
    publicationSeries.value = '';
    optionsCheck()
  
  }


}


const topicSelect = (payload) => {
  // projectTopics.value = payload.termTaxonomyId.toString()
  // optionsCheck()
    

  if(payload.termTaxonomyId){
    console.log( 'payload topics has termtaxid' )
    publicationTopics.value = payload.termTaxonomyId.toString()
    optionsCheck()
    console.log( publicationTopics )
    
  } else {
    console.log('notaxID');
    publicationTopics.value = '';
    optionsCheck()
  
  }


}


const sortSelect = (payload) => {

  console.log( 'SORT Payload' )
  console.log( payload )
  console.log( 'payload.value' )
  console.log( payload.value )
  
  if( payload.value === 'FEAT' || payload.value === undefined ){
        
      // console.log( 'its DATE ASC')
      publicationSort.value = 'DESC';
      sortField.value = 'DATE';
  

  } else {

    publicationSort.value = payload.value
    sortField.value = 'TITLE';
  }

}



const optionsCheck = () => {

  let series = publicationSeries.value.length !== 0 ? true : false;
  let topic = publicationTopics.value.length !== 0 ? true : false;
  

  if (series == true && topic == false) {
    
    console.log('series only')
    initialProjects.value = false
    showSeriesOnly.value = true
    showTopicOnly.value = false
    showSeriesTopic.value = false
  }

  if (series == false && topic == true) {
    
    console.log('topic only')
    console.log( publicationsTopicsResult )

    initialProjects.value = false
    showSeriesOnly.value = false
    showTopicOnly.value = true
    showSeriesTopic.value = false
  }

  if ( series == false && topic == false ) {
    
    console.log('topic only')
    initialProjects.value = true
    showSeriesOnly.value = false
    showTopicOnly.value = false
    showSeriesTopic.value = false
  }

  if (series == true && topic == true) {
    
    console.log('show all')
    initialProjects.value = false
    showSeriesOnly.value = false
    showTopicOnly.value = false
    showSeriesTopic.value = true
  }


  
}




let allSelected = ref(false);
let formatMe = ref([]);
let publicationsToShow = ref(12);
let currentURL = ref('');
const tax_input = ref('');
const dump = ref(false);
const resultObject = ref([]);

const onSearchInput = (e) => {  
  this.search_input.value = e.target.value;
  
}

const imgageUrl = (imageSrc) => {
  return imageSrc;
}

const showMoreResults = () => {
  publicationsToShow.value = publicationsToShow.value + 12;
}

const addSeriesVariables = (e) => {

  // console.log( 'options check')
  optionsCheck()

  // if (e) {

  //   let key = e.target.name.replace(/-/g, "")
  //   console.log( key )
  //   // publicationSeries.value[key] = e.target.checked ? e.target.value : "";

  // } else {

  //   console.log('calling from toggleseriesALL so show me search variables')
  //   // console.log(searchVariables)
  // }
}



/**
 * ::::::::: Get Filters :::::::::
 **/


/**
 * Get Publication topics Results
 **/
const { result: seriesResult, loading: seriesLoading, error: seriesError, options: seriesOptions, variables: seriesVariables 
} = useQuery( getPublicationsSeriesNames, { sort_order: publicationSort, sort_order_date: publicationSortDate } );

/**
 * Get Publication topics Results
 **/

const { result: topicsResult, loading: topicsLoading, error: topicsError, options: topicsOptions, variables: topicsVariables
} = useQuery( getTopics, { sort_order: publicationSort, sort_order_date: publicationSortDate } );





/**
 * ::::::::: Get Results :::::::::
 **/

/**
 * Initial Result
 **/
const { result: initialResult, loading: initialLoading, error: initialError, options: initialOptions, variables: initialVariables, refetch: initialRefetch
} = useQuery( publicationsInitialQuery, { search_input: search_input, sort_field: sortField, sort_order: publicationSort, exclude: true, featured: featuredPublications  } );



const { result: publicationsSeriesResult, loading: publicationsSeriesLoading, error: publicationsSeriesError, options: publicationsSeriesOptions, variables: publicationsSeriesVariables 
} = useQuery( getSeriesOnlyResult, { series:publicationSeries, search_input: search_input, sort_field: sortField, sort_order: publicationSort, exclude: true } );


/**
 * Get Publication topics Results
 **/

const { result: publicationsTopicsResult, loading: publicationsTopicsLoading, error: publicationsTopicsError, options: publicationsTopicsOptions, variables: publicationsTopicsVariables
} = useQuery( getTopicsOnlyResult, { topics: publicationTopics,search_input: search_input, sort_field: sortField, sort_order: publicationSort, exclude: true } );




/**
 * Get Publication Search Results
 **/

const { result: publicationsSeriesTopicResult, loading: publicationsSeriesTopicLoading, error: publicationsSeriesTopicError, options: publicationsSeriesTopicOptions, variables: publicationsSeriesTopicVariables
} = useQuery( publicationsSeriesTopics,{ series: publicationSeries, topics: publicationTopics, search_input: search_input, sort_field: sortField, sort_order: publicationSort, exclude: true } );








/**
 * ::::::::: Compute Publications Results :::::::::
 * 
 * 
 * Need to compute results so the we exclude publications that should not be
 * showing on the puiblications page
 **/







const computedResults = computed(() => {
  // console.log( 'initialResult=' );
  // console.log( initialResult );
  let returnResult = initialResult.value.publications.nodes.filter((element, index) => {
    // console.log(element)
    return element.publicationProperties.excludePublication !== true
  }

  );
  console.log( 'returnResult=' );
  console.log(returnResult)

  return returnResult;

})

const computedPublicationTopicsResults = computed((publicationsSeriesTopicLoading) => {
  // console.log('publicationsSeriesTopicRefetch=')
  // console.log(publicationsSeriesTopicRefetch)
  console.log( 'publicationsSeriesTopicResult' );
  console.log( publicationsSeriesTopicResult );
  let returnResult = publicationsSeriesTopicResult.value.publications.nodes.filter((element, index) => {
    // console.log(element)
    return element.publicationProperties.excludePublication !== true
  }

  );

  return returnResult;

})

const computedSeriesResults = computed(() => {

  let returnResult = publicationsSeriesResult.value.publications.nodes.filter((element, index) => {
    return element.publicationProperties.excludePublication !== true
  }

  );

  return returnResult;

})

const computedTopicsResults = computed(() => {

  let returnResult = publicationsTopicsResult.value.publications.nodes.filter((element, index) => {

    return element.publicationProperties.excludePublication !== true
  }

  );

  return returnResult;

})

// watch( () => searchVariables, (newvalue,oldvalue) => {

//   console.log( newvalue )


// })

</script>




















